module.exports = __webpack_public_path__ + "img/qr_dietz.b0843004.jpg";